import React from "react";
import { Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Sidebar from "./components/Sidebar";
import AppHeader from "./components/AppHeader";
import Dashboard from "./pages/Dashboard";
import Assignments from "./pages/Assignments";
import AssignmentSettings from "./pages/AssignmentSettings";
import Matters from "./pages/Matters";
import MatterDetail from "./pages/MatterDetail";
import Clients from "./pages/Clients";
import StaffMaster from "./pages/StaffMaster";
import Reports from "./pages/Reports";
import Attendance from "./pages/Attendance";
import AttendanceReport from "./pages/AttendanceReport";
import Login from "./pages/Login";
import Billing from "./pages/Billing";
import BillingSettings from "./pages/BillingSettings";
import QuickWorks from "./pages/QuickWorks";
import DscManagement from "./pages/DscManagement";
import Settings from "./pages/Settings";
import AttendanceSettings from "./pages/AttendanceSettings";
import QuickWorkSettings from "./pages/QuickWorkSettings";
import BrandingSettings from "./pages/BrandingSettings";
import MatterTemplateSettings from "./pages/MatterTemplateSettings";
import ClientPortalDashboard from "./pages/ClientPortalDashboard";
import ClientPortalDocuments from "./pages/ClientPortalDocuments";
import ClientPortalWorkUpdates from "./pages/ClientPortalWorkUpdates";
import ClientPortalLayout from "./components/clientPortal/ClientPortalLayout";
import AccessDenied from "./pages/AccessDenied";
import CommunicationCentre from "./pages/CommunicationCentre";

function InternalProtectedLayout() {
  const { user, userData } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (userData?.profileType === "client") return <Navigate to="/client" replace />;
  if (!userData?.active || userData?.profileType !== "staff") return <Navigate to="/access-denied" replace />;
  return <div className="app-shell"><Sidebar /><div className="app-main"><AppHeader /><main className="app-content"><Outlet /></main></div></div>;
}

function CommunicationCentreRoute() {
  const { userData } = useAuth();
  const allowed = userData?.profileType === "staff" && userData?.active && String(userData?.role || "").toLowerCase() === "partner" && userData?.communicationCentreEnabled === true;
  return allowed ? <CommunicationCentre /> : <Navigate to="/dashboard" replace />;
}

function ClientProtectedLayout() {
  const { user, userData } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (userData?.profileType === "staff" && userData?.active) return <Navigate to="/dashboard" replace />;
  if (userData?.profileType !== "client" || !userData?.active) return <Navigate to="/access-denied" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route element={<ClientProtectedLayout />}>
        <Route path="/client" element={<ClientPortalLayout />}>
          <Route index element={<ClientPortalDashboard />} />
          <Route path="documents" element={<ClientPortalDocuments />} />
          <Route path="work-updates" element={<ClientPortalWorkUpdates />} />
        </Route>
      </Route>
      <Route element={<InternalProtectedLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/staff-master" element={<StaffMaster />} />
        <Route path="/staff" element={<Navigate to="/staff-master" replace />} />
        <Route path="/assignments" element={<Assignments />} />
        <Route path="/matters" element={<Matters />} />
        <Route path="/matters/:matterId" element={<MatterDetail />} />
        <Route path="/assignment-settings" element={<AssignmentSettings />} />
        <Route path="/tasks" element={<Navigate to="/assignments" replace />} />
        <Route path="/quick-works" element={<QuickWorks />} />
        <Route path="/dsc-management" element={<DscManagement />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/attendance-settings" element={<AttendanceSettings />} />
        <Route path="/quick-work-settings" element={<QuickWorkSettings />} />
        <Route path="/branding-settings" element={<BrandingSettings />} />
        <Route path="/matter-template-settings" element={<MatterTemplateSettings />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/billing-settings" element={<BillingSettings />} />
        <Route path="/communication-centre" element={<CommunicationCentreRoute />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/attendance-report" element={<AttendanceReport />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
